import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-opening-times-dialog',
  templateUrl: './opening-times-dialog.component.html',
  styleUrls: [],
})
export class OpeningTimesDialogComponent {
  nameFormControl: FormControl = new FormControl();
  gmt: boolean = true;
  openingTimes: any[] = [];
  altOpeningTimes: any[] = [];
  submitted = false;
  form!: FormGroup;
  isEditMode = false;
  isUK: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<OpeningTimesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isUK = data?.country === 'United Kingdom';
    this.nameFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required
    );

    this.openingTimes = this.createDefaultOpeningTimes();
    this.altOpeningTimes = this.createDefaultOpeningTimes();

    this.form = this.fb.group({
      name: this.nameFormControl,
    });

    if (data?.group) {
      this.isEditMode = true;
      this.nameFormControl.setValue(data.group.name);
      if (data.group.openingTimes) {
        this.openingTimes = data.group.openingTimes;
      }
      if (data.group.altOpeningTimes) {
        this.altOpeningTimes = data.group.altOpeningTimes;
      }
    }
  }

  private createDefaultOpeningTimes() {
    const days = [
      { day: 'Monday', label: 'Mon' },
      { day: 'Tuesday', label: 'Tue' },
      { day: 'Wednesday', label: 'Wed' },
      { day: 'Thursday', label: 'Thu' },
      { day: 'Friday', label: 'Fri' },
      { day: 'Saturday', label: 'Sat' },
      { day: 'Sunday', label: 'Sun' },
    ];

    return days.map(({ day, label }) => ({
      fromControl: new FormControl(
        { value: '08:00', disabled: false },
        Validators.required
      ),
      toControl: new FormControl(
        { value: '18:00', disabled: false },
        Validators.required
      ),
      day,
      label,
      active: true,
    }));
  }

  toggleDay(day: any, active: boolean) {
    day.active = active;
  }

  save() {
    if (!this.nameFormControl.value?.trim()) {
      return;
    }

    this.dialogRef.close({
      name: this.nameFormControl.value,
      openingTimes: this.openingTimes,
      altOpeningTimes: this.altOpeningTimes,
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
